/* tslint:disable */
/* eslint-disable */
/**
 * AIS Database Loader API
 * API for retrieving AIS database and filestore date ranges.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DailyRangeGet200Response,
} from '../models';
import {
    DailyRangeGet200ResponseFromJSON,
    DailyRangeGet200ResponseToJSON,
} from '../models';

/**
 * 
 */
export class DatabaseLoaderApi extends runtime.BaseAPI {

    /**
     * Retrieves the available date ranges for AIS data in both the database and filestore.
     * Get available date ranges
     */
    async dailyRangeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyRangeGet200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/daily/range`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyRangeGet200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the available date ranges for AIS data in both the database and filestore.
     * Get available date ranges
     */
    async dailyRangeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyRangeGet200Response> {
        const response = await this.dailyRangeGetRaw(initOverrides);
        return await response.value();
    }

}
